module.exports = __webpack_public_path__ + "static/official_footer-6801397e4720b3b66c619202f49eb0fb.jpg";